define([
	"csi/_base/modules",
	"csi/_base/underscore",
	"csi/access/crews",
	"csi/action",
	"csi/api",
	"csi/canvas/storeFactory",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/reflection",
	"csi/reflectionHints",
	"csi/state/rootStore",
	"csi/utility/routerUtility",
	"csi/view",
	"csi/xml",
	"lodash",
	"./apparelService",
	"./ProductType",
	"csi/def",

	"./PriceList/ChangeFreezeStatus",
	"./Theme/AddColorwayToThemeAction",
	"./GenerateLabelFileAction",
	"./Theme/NewThemeFromMaterialAction",
	"./Theme/NewThemeFromStyleAction",
	"./Theme/ThemePopupStyleColorways",
	"./PrintDesign/PrintDesignColorsSwitchboard",
	"./PrintDesign/Positions"
], function(modules, _, crews, csiAction, api, storeFactory, PostRequest, locale, reflection, reflectionHints,
	{routerStore, watchStoreProperty, featureTogglesStore}, routerUtility, csiView, xml, {reject, filter}, {augmentColorMaterialKeys}, ProductType, def) {

	var COLOR_MATERIAL = "ColorMaterial";
	var COLOR_COLORWAY_CONTEXT = "ColorColorwayContext";
	var MATERIAL = "Material";
	var STYLE = "Style";
	var THEME = "Theme";

	// add ColorMaterialSample keys to views of ColorMaterial
	reflection.registerAugmentDomainKeysByTypeFunction(COLOR_MATERIAL, augmentColorMaterialKeys);

	routerUtility.registerHomeTab("ThemeMaster", "ThemeMasters");
	routerUtility.registerHomeTab("ShapeMaster", "ShapeMasters");

	storeFactory.add(THEME, COLOR_MATERIAL, "Child:PlanColorMaterials");
	storeFactory.add(THEME, COLOR_COLORWAY_CONTEXT, "Child:ColorColorways");
	storeFactory.add(THEME, MATERIAL, "Child:PlanMaterials");
	storeFactory.add(THEME, STYLE, "Parent:Theme");

	api.addCommentPath("Style", xml.path("ProductSourcing", "ProductSources"));
	api.addCommentPath("Style", xml.path("ProductSourcing", "ProductSources", "Samples"));
	api.addCommentPath("Style", xml.path("ProductSourcing", "ProductSources", "SupplierItems"));

	api.addCommentPath("Material", xml.path("ProductSourcing", "ProductSources"));
	api.addCommentPath("Material", xml.path("ProductSourcing", "ProductSources", "Samples"));
	api.addCommentPath("Material", xml.path("ProductSourcing", "ProductSources", "SupplierItems"));

	// add these to cover this path - (PartMaterial)Child:Actual(Product) so that the RecentChildComments will be resolved properly
	api.addCommentPath("Product", xml.path("ProductSourcing", "ProductSources"));
	api.addCommentPath("Product", xml.path("ProductSourcing", "ProductSources", "Samples"));
	api.addCommentPath("Product", xml.path("ProductSourcing", "ProductSources", "SupplierItems"));


	api.addCommentPath("Shape", xml.path("ProductSourcing", "ProductSources"));
	api.addCommentPath("Shape", xml.path("ProductSourcing", "ProductSources", "Samples"));

	// do not allow linking to hidden color material
	api.addLinkValidation("ColorMaterial", ({Hidden}) => !Hidden);

	// do not allow linking to special color (owned by ColorColorwayContext)
	api.addLinkValidation("ColorSpecification", ({__Parent__}) => !xml.isValidURL(__Parent__));

	// do not allow linking to hidden or special materials
	api.addLinkValidation("Material", ({Hidden, Special}) => !Hidden && !Special);

	// do not link to sources if under special or hidden materials
	api.addLinkValidation("ProductSource", ({OKToBrowse}) => OKToBrowse);

	api.addSpecialPath("ColorSpecification", "Child:Actual");
	api.addSpecialPath("ColorSpecification", "Child:ColorSpecification");
	api.addSpecialPath("Material", "Child:Actual");

	csiAction.registerControllers("PriceList", {
		"RevertToDraft": "Apparel/PriceList/RevertToDraft",
		"Revise": "Apparel/PriceList/Revise"
	});

	locale.registerDisplayNameResolver("StructureItemDefaults", locale.displayNameOrType);

	reflectionHints.setLocationLayoutCallback("Material", function(tabsView, node, revisionNode) {
		const compositionFeatureFlagEnabled = featureTogglesStore.MATERIAL_COMPOSITION;

		if (!compositionFeatureFlagEnabled) {
			const omitIds = {"Composition": true};

			tabsView.tabs = reject(tabsView.tabs, (tab) => omitIds[tab.m_idView]);
		}
	});

	reflectionHints.setLocationLayoutCallback("Style", function(tabsView, node, revisionNode) {
		if (xml.nodeIsArchived(node)) {
			tabsView.tabs = def.getNodeViewDef(node, "__Base__").tabs.filter((tab)=> tab.m_idView === "Properties");
		}
	});

	/** Mark state locationIsDormant if Season is in breadcrumb and is frozen */
	watchStoreProperty(routerStore, "locationUrl", () => {
		const season = routerStore.getBreadcrumbNode("Season");
		routerStore.setLocationIsDormant(xml.nodeHasFlag(season, xml.NODE_FLAG_FROZEN));
	}
	);

	function refreshStyleImages(/*Node*/node) {
		if (node) {
			return new PostRequest("Apparel", "RefreshScene7Image")
				.addParameter("ParentURL", node.$URL)
				.post({});
		}

		return null;
	}

	return {
		refreshStyleImages,

		sampleGetProduct: function(cache, /*Node*/sample) {
			const path = "Child:__Parent__/Child:__Parent__/Child:__Parent__";
			let product = routerStore.getBreadcrumbNode("Style") ||
				routerStore.getBreadcrumbNode("Material") ||
				cache.getPathNode(sample, path);

			if (!product) {
				cache.addNode(sample.$URL, function(req) {
					req.addDependencyPaths([path]);
				});

				product = cache.getPathNode(sample, path);
			}

			return product;
		},

		onActionSeasonStatus: function(ac) {
			// summary: Allow Season name and Code to be edited only when Status is Pending
			var oldValue = ac.oldValue;
			var newValue = ac.newValue;

			if (oldValue == newValue) return;
			if (oldValue != "SeasonStatus:Pending" && newValue != "SeasonStatus:Pending") return;

			if (newValue == "SeasonStatus:Pending") {
				ac.m_writer.changeNode(ac.m_urlNode)
					.changeAttributeFlag(xml.ATTR_NAME, xml.ATTR_FLAG_NOEDIT, false, true)
					.changeAttributeFlag("Code", xml.ATTR_FLAG_NOEDIT, false, true);
			} else {
				ac.m_writer.changeNode(ac.m_urlNode)
					.changeAttributeFlag(xml.ATTR_NAME, xml.ATTR_FLAG_NOEDIT, true, false)
					.changeAttributeFlag("Code", xml.ATTR_FLAG_NOEDIT, true, false);
			}

			ac.bRefreshNode = true;
		},

		/**
		 * Redraw MaterialSizes view when Size Range is changed
		 * @param {Controller} ac
		 */
		postActionMaterialSizes(ac) {
			ac.widget.getSiblingView("MaterialSizes")?.redraw();
		},

		postActionProductSizes: function(ac) {
			var viewParent = ac.widget.viewParent;
			var view = viewParent ? viewParent.getChildView("Sizes") : null;
			if (view) {
				view.cacheView.put(ac.getNode());
				view.refreshWidget();
			}
		},

		onAccessActionNotPopupView: function(/*Context*/ctx, /*Action*/action) {
			return !ctx.bPopup;
		},

		onAccessActionStyleShape: function(/*Context*/ctx, /*Action*/action) {
			return xml.nodeHasAccess(ctx.getNode(), xml.RIGHT_WRITE, 'Shape');
		},

		onAccessActionConfigPriceList: function(/*Context*/ctx, /*Action*/action) {
			return crews.isInRoles(["Price List Config Administrator"], ctx.getContextNode());
		},

		onAccessActionNewStyleShape: function(/*Context*/ctx, /*Action*/action) {
			const shape = ctx.getContextNode();
			const shapeMaster = ctx.cache.getNode(shape.__Parent__);

			return shape.Active && (shapeMaster.AllSeasons || !_.isEmpty(shape.ShapeSeasons));
		},

		onAccessActionResetStockLevel: function(/*Context*/ctx, /*Action*/action) {
			const sku = ctx.getNode();
			return crews.isInRoles(["Stock Order Administrator"], sku) //
				&& ctx.cache.getNode(sku.__Parent__).IsStockManaged;
		},

		onAccessActionStyleAssignedAgents: function(/*Context*/ctx, /*Action*/action) {
			return crews.isInRoles(["Team Manager"], ctx.getNode());
		},

		onAccessActionStyleCopy: function(/*Context*/ctx, /*Action*/action) {
			return crews.isInRoles(["Style Administrator"], ctx.getNode()) && ProductType.get(ctx.getNode(), "Available");
		},

		onAccessActionStyleTypeDelete: function(/*Context*/ctx, /*Action*/action) {
			return !xml.nodeGetAttributeValue(ctx.getNode(), "Published");
		},

		onAccessActionStyleTypeSetToAllStyles: function(/*Context*/ctx, /*Action*/action) {
			return xml.nodeGetAttributeValue(ctx.getNode(), "Published");
		},

		onAccessActionEditShapeSeason: function(/*Context*/ctx, /*Action*/action) {
			return false;
		},

		postActionCollectionStyleType: function(ac) {
			// summary: update Styles view with new Style Type setting
			var view = csiView.getView("Styles");
			if (view) {
				view.cacheView.put(ac.getNode());
			}
		},

		onAccessProductTypeAttribute: function(/*Context*/ctx, /*Action*/action) {
			const productType = ctx.getNodeParent();
			const prodConfig = productType.Published ? ctx.cache.get(productType.ProductionConfig) : null;
			const map = prodConfig?.[action.heading.m_id];
			return !map?.[ctx.keyValue];
		},

		postActionRefreshProperties(ac) {
			csiView.getView("Properties")?.refreshWidget();
		},

		postActionColorDefault3DChanged(ac) {
			csiView.refreshAllViewsOnTab("Documents");
		},

		postActionDefault3DChanged(ac) {
			//Refresh the Material - Properties and documents view upon new 3d material selection
			this.postActionRefreshProperties(ac);
			csiView.getView("Documents")?.refreshWidget();
			csiView.getView("ProductColors")?.refreshWidget();
		},

		postActionMaterialSizeRange: function(ac) {
			//Refresh the Material - Properties view upone SizeRange changes
			var view = csiView.getView("MaterialProperties");
			if (view) {
				view.refreshWidget();
			}
		},

		postActionNewSupplierRequest: function(ac) {
			_.each(csiView.getAllViews("SupplierRequests"), function(view) {
				view.when(view.refreshWidget(), function() {
					view.postAction();
				});
			});
		},

		onActionCopyColorMaterial: function(ac) {
			// summary: when colored material is copied, associate the new node to the same material
			var materialAttributes = xml.nodeGetAttributeValue(ac.m_nodeSource, xml.ATTR_PARENT);
			if (materialAttributes) {
				ac.m_writer.changeParent(materialAttributes, "ProductColors", xml.ATTR_REFLIST, [ac.m_urlNode], true);
			}
		},

		postActionColorMaterials: function(/*Controller*/ac) {
			// summary: update properties view display of DefaultColor when colored materials are changed
			const view = ac.widget.getSiblingView("Properties");
			const h = view?.defView.findHeading("DefaultColor");
			if (h) {
				view.refreshHeading(h);
			}
		},

		postSelectSizeChartSubSizeRanges: function(ac) {
			ac.widget.refreshHeadingStore(ac.widget.defView.findHeading("BaseSize", false));
		},

		postActionSampleStorageOnActiveChange: function(/*Controller*/ac) {
			// summary: when the Active state is changed
			function refreshChildView(viewId) {
				var view = ac.widget.viewParent.getChildView(viewId);
				if (view) {
					view.refreshWidget();
				}
			};

			if (ac.widget.viewParent) {
				refreshChildView("MaterialSamples");
				refreshChildView("StyleSamples");
			}
		},

		onAccessActionPopupProductColors: function(/*Context*/ctx, /*Action*/action) {
			var isProductSupportColor = ProductType.get(ctx.getNode(), "HasColor");
			var isProductColorMatrix = !!ctx.defView.findHeading("ProductColors", false);
			return isProductColorMatrix && isProductSupportColor;
		},

		onAccessActionLinkColorInPalettes: function(/*Context*/ctx, /*Action*/action) {
			return crews.isInRoles(["Material Administrator", "Material Editor"], ctx.getNode());
		},

		onAccessActionCreateIssue: function(/*Context*/ctx, /*Action*/action) {
			const node = ctx.getContextNode();

			return !xml.nodeIsFrozen(node) &&
				ctx.defView.findHeading("Issues", "Child:IssueLog") &&
				crews.isInRoles(["Issue Administrator"], node);
		},

		onAccessActionMainMaterialsList: function(/*Context*/ctx, /*Action*/action) {
			return !!ctx.defView.findHeading('MainMaterialsList');
		},

		onAccessActionCreateMainMaterialsList: function(/*Context*/ctx, /*Action*/action) {
			return this.onAccessActionMainMaterialsList(ctx, action) && _.filter(ctx.getNode().SampleDataSheets, function(sds) {
				var sdsNode = ctx.cache.getNode(sds);
				return sdsNode && (sdsNode.$Type == "ApparelBOM" || sdsNode.$Type == "MaterialBOM");
			}
			).length == 0;
		},

		onAccessActionCreateReviewStyle: function(/*Context*/ctx, /*Action*/action) {
			if (!modules.hasModule("ProductSpec")) return false;
			var product = this.sampleGetProduct(ctx.cache, ctx.getParent());
			return product && !product.Hidden && product.$Type == "Style";
		},

		onAccessActionCreateSampleBOM: function(/*Context*/ctx, /*Action*/action) {
			var product = this.sampleGetProduct(ctx.cache, ctx.getParent());

			if (!product || product.Hidden) return false;

			var bStyle = product.$Type == "Style";
			return modules.hasModule(bStyle ? "ProductSpec" : "MaterialSpec") && ProductType.hasTDS(product, bStyle ? "ApparelBOM" : "MaterialBOM");
		},

		onAccessActionCreateSampleBOMinSupplierRequest: function(/*Context*/ctx, /*Action*/action) {
			var sr = ctx.view.getViewNode();

			if (sr.State === "SupplierRequestState:Complete") return false;

			return this.onAccessActionCreateSampleBOM(ctx, action);
		},

		onAccessActionCreateShape: function(/*Context*/ctx, /*Action*/action) {
			const node = ctx.getContextNode();
			if (action.getId() === "NewShapeFromStyle") {
				return crews.isInRoles(["Shape Administrator", "Shape Editor"], node);
			}

			return crews.isInRoles(["Shape Administrator"], node);
		},

		onAccessActionCreateTheme: function(/*Context*/ctx, /*Action*/action) {
			const node = ctx.getContextNode();

			return crews.isInRoles(["Theme Administrator"], node);
		},

		/**
		 * Determines if a user has Write access to a Theme attribute on a Style so it can be unassociated (deleted the association)
		 * @param {Context} ctx - Context object reference that contains the context of the current row on the current view
		 * @param {Action} item - Action object reference that has information for the related action for the access check
		 * @return {boolean) - true if the user can delete the association, otherwise false
		 */
		onAccessActionDeleteThemeStyle: function(ctx, action) {
			return xml.nodeHasAccess(ctx.getNode(), xml.RIGHT_WRITE, 'Theme');
		},

		/**
		 * Determines if a user has Write access to an InspirationTheme attribute on an InspirationStyle so it can be unassociated (deleted the association)
		 * @param {Context} ctx - Context object reference that contains the context of the current row on the current view
		 * @param {Action} item - Action object reference that has information for the related action for the access check
		 * @return {boolean) - true if the user can delete the association, otherwise false
		 */
		onAccessActionDeleteInspirationThemeStyle: function(ctx, action) {
			return xml.nodeHasAccess(ctx.getNode(), xml.RIGHT_WRITE, 'InspirationTheme');
		},

		onActionColorPaletteRuleOnMaterialType: function(ac) {
			if (ac.newValue == "ColorPaletteRuleTypes:Enforced") {
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("AllowCreateColoredMaterialOnPlacement", xml.ATTR_BOOLEAN, false);
			}
		},

		onActionColorPaletteRuleOnStyleType: function(ac) {
			if (ac.newValue != "ColorPaletteRuleTypes:Off") {
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("AllowCreateColorSpecOnColorway", xml.ATTR_BOOLEAN, false);
			}
		},

		/**
		 * Display the tab only if "EngineeringChange" module is installed and if the feature flag "Enable Impact Analysis" is true
		 * @param {Context} ctx
		 * @param {Tab} defTab
		 * @param {string} rootNodeType
		 * @param {Node?} rootNode
		 */
		onAccessTabImpactAnalysis: function(ctx, defTab, rootNodeType, rootNode) {
			return modules.hasModule("EngineeringChange") && featureTogglesStore.ENABLE_IMPACT_ANALYSIS;
		},

		/**
		 * Determines if a node is derived from a given type
		 * @param {C8Node} node - node to be checked
		 * @param {String} type - Node type to be compared against
		 * @return {boolean) - true if the node derived from type.
		 */
		isDerivedFrom(node, type) {
			const rc = reflection.getClass(node.$Type);
			return rc.isDerivedFrom(type);
		},
		/**
		 * initializes name of new node to "Theme BOM" if name wasnt already set in a form
		 * @param {Action} ac
		 */
		onActionNewThemeBOMTypeName: function(ac) {
			const fd = ac.m_formData;
			const field = fd && fd.getField(xml.ATTR_NAME);
			const name = field && field.getValue();

			if (!fd || !name) {
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute(xml.ATTR_NAME, xml.ATTR_STRING, "Theme BOM");
			}
		},

		/**
		 * Refreshes child view if exists, otherwise do nothing
		 * @param {string} viewId - ID of the view to refresh
		 */
		refreshChildViewIfExists: function(viewId) {
			const childView = csiView.getView(viewId);
			if (childView && childView.isValidView()) {
				childView.refreshWidget();
			}
		},

		/**
		 * Clear QuoteChangeFromState entries when we remove Supplier Quote
		 * @param {Action} ac
		 */
		onActionAutomateStateStatusChange: function(ac) {
			if (!ac.newValue.includes('AutomateStateStatusChanges:SupplierItem')) {
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("QuoteChangeFromState", xml.ATTR_ENUMLIST, []);
			}
			if (!ac.newValue.includes('AutomateStateStatusChanges:Sample')) {
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("SampleChangeFromStatus", xml.ATTR_ENUMLIST, []);
				ac.m_writer.changeNode(ac.m_urlNode).changeAttribute("SampleChangeToStatus", xml.ATTR_ENUM, "SampleStatus:");
			}
		},
	};
});
